interface Props {
  className: string;
  children: React.ReactNode;
  expandedChildren: React.ReactNode;
  style: React.CSSProperties;
  row?: { original: { isExpanded: boolean } };
}

const TrComponent = ({ className, children, expandedChildren, style, row }: Props) => {
  return (
    <>
      <div role="row" className={`${className} rt-tr`} style={{ ...style, borderBottom: "1px solid #EEE" }}>
        {children}
      </div>
      {row && row.original.isExpanded && (
        <div style={{ backgroundColor: "#efefef", padding: "2rem" }}>{expandedChildren}</div>
      )}
    </>
  );
};

export default TrComponent;
